import { Button, EmptyState } from "@cmde/shadcn";
import { KeyRoundIcon, PlusIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

export function EmptyCredentialsList({ createHref }: { createHref: string }) {
  const { t } = useTranslation();

  return (
    <EmptyState
      title={t("credentials.list.general.no_credentials_found")}
      description={t("credentials.list.general.add_user_to_get_started")}
      icon={<KeyRoundIcon />}
    >
      <Button asChild>
        <Link to={createHref}>
          <PlusIcon />
          {t("credentials.create.action")}
        </Link>
      </Button>
    </EmptyState>
  );
}
